import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiBill, ApiPaymentLink } from '@app/packages/api/v2/types/entities'

export const postBillsByIdPaymentLink = (id: string) =>
  createApiAction('postBillsByIdPaymentLink', dispatch =>
    dispatch<{ data: ApiPaymentLink; included?: ApiBill[] }>({ method: 'POST', endpoint: urlEscaped`/api/v2/bills/${id}/payment_link` })
  )
